import { URLS } from "fire-wind-water";

const config: { [label: string]: any } = (window as any).stemplateConfig || {};

export const settings: any = {
  isPreview: config.isPreview || false,
  tenantId: config.tenantId || null,
  schemaId: config.schemaId || null,
  customFormId: config.customFormId || null,
  memberFormId: config.memberFormId || null,
  memberFormUrl: config.memberFormUrl || null,
  siteId: config.siteId || null,
  instanceId: config.instanceId || null,
  category: config.category || null,
  total: config.total || null,
  current: config.current || null,
  showCount: config.showCount || null,
  pageUrl: config.pageUrl || null,
  isDesign: config.isDesign || URLS.getURL("des"),
  channel_code: URLS.getURL("pk_source"),
  pk_campaign: URLS.getURL("pk_campaign"),
  isNotLink: parseInt(URLS.getURL("isNotLink"), 10),
  clientIP: "127.0.0.0",
  pageId: config.pageId || "",
  menuId: config.menuId || null,
  objId: config.objId || null,
  isNavShow: config.isNavShow == 1,
  navType: config.navType,
  pid: config.pid,
  t: null,
  pageInfo: {},
  page: {},
  urls: [
    "f.smarket.net.cn",
    "file.smarket.net.cn",
    "saas-project.sinobase.cn",
    "activity.sangfor.com.cn",
  ],
  thirdCode: "",
  pcTitle: "",
  wapTitle: "",
  pcLongUrl: "",
  wapLongUrl: "",
};

if (settings.isPreview) {
  settings.tenantId = URLS.getURL("tid") || (window['siteParams']?window['siteParams'].tid:null);
  settings.siteId = URLS.getURL("sid") || (URLS.getURL("des")?null : (window['siteParams']?window['siteParams'].sid:null));
  settings.category = URLS.getURL("cy") || (URLS.getURL("des")?null : (window['siteParams']?window['siteParams'].cy:null));
  settings.pageId = URLS.getURL("pid") || (URLS.getURL("des")?null : (window['siteParams']?window['siteParams'].pid:null));
  settings.menuId = URLS.getURL("menuId");
  settings.t = parseInt(URLS.getURL("t") || (URLS.getURL("des")?null : (window['siteParams']?window['siteParams'].t:null)), 10);
}

const wd = window as any;

export { wd };

export const $cmsData = {
  data: [],
  container: {},
};
